<template>
    <div class="signoff-page">
        <div class="signoff-summary" style="margin-bottom: 12px;">
            <strong>Pending:</strong>
            <span class="label label-default">{{ counts.total }}</span>
            &nbsp;•&nbsp; Sales <span class="label label-warning">{{ counts.sales }}</span>
            &nbsp;•&nbsp; Won <span class="label label-info">{{ counts.won }}</span>
            &nbsp;•&nbsp; Inspection <span class="label label-primary">{{ counts.inspection }}</span>
        </div>

        <ul class="nav nav-tabs" role="tablist">
            <li v-if="userRoles.block1 || userRoles.override" :class="{ active: activeTab === 'sales' }">
                <a href="#" @click.prevent="activeTab = 'sales'">
                    Sales <span class="badge">{{ counts.sales }}</span>
                </a>
            </li>
            <li v-if="userRoles.block2 || userRoles.override || userRoles.preproduction" :class="{ active: activeTab === 'won' }">
                <a href="#" @click.prevent="activeTab = 'won'">
                    Won <span class="badge">{{ counts.won }}</span>
                </a>
            </li>
            <li v-if="userRoles.block3 || userRoles.override" :class="{ active: activeTab === 'inspection' }">
                <a href="#" @click.prevent="activeTab = 'inspection'">
                    Inspection <span class="badge">{{ counts.inspection }}</span>
                </a>
            </li>
        </ul>

        <div class="tab-content" style="padding-top: 16px;">
            <div v-show="activeTab === 'sales'">
                <signoff-sales-tab :can-override="userRoles.override" @approved="refreshCounts" />
            </div>
            <div v-show="activeTab === 'won'">
                <signoff-won-tab :can-override="userRoles.override"
                                 :can-approve="userRoles.block2 || userRoles.override"
                                 @approved="refreshCounts" />
            </div>
            <div v-show="activeTab === 'inspection'">
                <signoff-inspection-tab :can-override="userRoles.override" @approved="refreshCounts" />
            </div>
        </div>
    </div>
</template>

<script>
import SignoffSalesTab from './SignoffSalesTab.vue';
import SignoffWonTab from './SignoffWonTab.vue';
import SignoffInspectionTab from './SignoffInspectionTab.vue';

/*
    Top-level component for /quotes/signoff. Three-tab UI; each tab only
    visible to users with the matching approver role (or override). The
    blade wrapper passes userRoles as a prop based on SignoffActors.

    Pending counts polled every 30s. After an approve action inside a
    tab, the child emits 'approved' and we refresh counts immediately
    rather than wait for the next poll tick.

    See planning/quote-signoff-design.md §7.1–§7.7.
*/
export default {
    components: { SignoffSalesTab, SignoffWonTab, SignoffInspectionTab },
    props: {
        userRoles: {
            type: Object,
            required: true,
            // shape: { block1: bool, block2: bool, block3: bool, override: bool }
        },
    },
    data() {
        return {
            counts: { sales: 0, won: 0, inspection: 0, total: 0 },
            activeTab: 'sales',
            pollHandle: null,
        };
    },
    mounted() {
        this.activeTab = this.firstAccessibleTab();
        this.refreshCounts();
        this.pollHandle = setInterval(this.refreshCounts, 30_000);
    },
    beforeDestroy() {
        if (this.pollHandle) clearInterval(this.pollHandle);
    },
    methods: {
        firstAccessibleTab() {
            // Pre-production team lands straight on their tab: Won.
            if (this.userRoles.preproduction && !this.userRoles.block1) return 'won';
            if (this.userRoles.block1 || this.userRoles.override) return 'sales';
            if (this.userRoles.block2 || this.userRoles.override) return 'won';
            if (this.userRoles.block3 || this.userRoles.override) return 'inspection';
            return 'sales';
        },
        refreshCounts() {
            fetch('/api/signoff/pending-counts', { headers: { Accept: 'application/json' }})
                .then(r => r.json())
                .then(data => { this.counts = data; })
                .catch(() => {});
        },
    },
};
</script>
